import { COFFEE_ROUTE_NAMES, COFFEE_PREVIEW_KIND } from "@/apps/coffee/coffee.routes";
import { goToField } from "@/shared/utils";

export function useCoffeeGoTo() {
    return {
        goToContentField(fieldId) {
            goToField(COFFEE_ROUTE_NAMES.projectContent, COFFEE_PREVIEW_KIND.coffee, fieldId);
        },
    };
}
